<template>
  <HeaderComponent />
  <div class="profileBlock">
    <div class="goBack">
      <img src="../assets/icons/arrowLeft.svg" />
      <p @click="goBack">Назад</p>
    </div>
    <div class="profileBlockInfo">
      <p class="profileHeadText">Ваш профиль</p>
      <div class="profileMainInfo">
        <div class="userInfo">
          <div class="userInfoText">
            <img src="../assets/icons/avatarProfile.svg" />
            <div class="userText">
              <p class="userTextHead">{{ user.login }}</p>
              <p class="userTextData">id{{ user.numId }}</p>
            </div>
          </div>
          <button class="logoutButton" @click="logoutButton">Выйти</button>
        </div>
        <div class="userInfo">
          <img src="../assets/icons/calendar.svg" width="36px" />
          <div class="userText">
            <p class="userTextHead">Дата регистрации</p>
            <p class="userTextData">{{ new Date(parseInt(user._id.substring(0, 8), 16) * 1000).toLocaleDateString("ru-RU") }}</p>
          </div>
        </div>
      </div>
      <div class="profileCategories">
        <div class="profileCategory selectedProfileCategory" @click="changeCategory">Избранное</div>
        <div class="profileCategory" @click="changeCategory">История заказов</div>
      </div>
      <div class="workBlock">
        <div class="favouriteBlock" v-if="profileCategory == 'favourite'">
          <p v-if="favouriteGirls.length == 0">В данный момент у вас нет избранных девушек.</p>
          <div class="listQuestionnaires" v-if="favouriteGirls">
            <GirlCard
              v-for="girl in favouriteGirls"
              :key="girl._id"
              :girl="girl"
              :cityName="girl.addCity ? girl.addCity.name : ''"
              @photo-click="reserveGirl"
              @reserve-click="reserveGirl"
            />
          </div>
        </div>
        <div class="historyBlock" v-else>
          <p v-if="historyGirls.length == 0">В данный момент у вас нет заказов.</p>
          <div class="listQuestionnaires" v-if="historyGirls">
            <GirlCard
              v-for="girl in historyGirls"
              :key="girl.girlId._id"
              :girl="girl"
              girlDataKey="girlId"
              :cityName="girl.orderCity ? girl.orderCity.name : ''"
              :linkHref="'/girl/' + girl.girlId._id"
            >
              <template #action>
                <div class="paymentStatus">
                  <p>Статус оплаты:</p>
                  <p v-if="girl.status == 'SUCCESS'" class="paymentStatusText paymentPaid">Оплачено</p>
                  <p v-else class="paymentStatusText paymentNotPaid" @click="openPayment" :id="girl._id">
                    Не оплачено
                    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.53033 6.53033C6.82322 6.23744 6.82322 5.76256 6.53033 5.46967L1.75736 0.696699C1.46447 0.403806 0.989592 0.403806 0.696699 0.6967C0.403805 0.989593 0.403805 1.46447 0.696699 1.75736L4.93934 6L0.6967 10.2426C0.403806 10.5355 0.403806 11.0104 0.6967 11.3033C0.989593 11.5962 1.46447 11.5962 1.75736 11.3033L6.53033 6.53033ZM5 6.75L6 6.75L6 5.25L5 5.25L5 6.75Z" fill="#E64646" />
                    </svg>
                  </p>
                </div>
              </template>
            </GirlCard>
          </div>
          <div class="reservationBackground" v-if="isOpenPayment">
            <div class="reservationBlock">
              <div class="modalHeader">
                <img src="../assets/icons/logo.svg" />
                <div class="closeAuth" @click="closeModal">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14L13.7279 1.27208" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
                    <path d="M1 1L13.7279 13.7279" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
              <PaymentCard :paymentData="girlPaymentData.data.result" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterComponent />
</template>

<script>
  import FooterComponent from "@/components/FooterComponent.vue"
  import HeaderComponent from "@/components/HeaderComponent.vue"
  import GirlCard from "@/components/GirlCard.vue"
  import PaymentCard from "@/components/PaymentCard.vue"
  import axios from "axios"
  import { useToast } from "vue-toastification"

  export default {
    name: "ProfilePage",
    data() {
      return {
        user: this.$store.getters.getUserData,
        profileCategory: "favourite",
        favouriteGirls: [],
        historyGirls: [],
        isOpenPayment: false,
        girlPaymentData: null,
      }
    },
    methods: {
      goBack() {
        window.history.back()
      },
      changeCategory(event) {
        let e = event.target.closest("div")
        let categories = document.querySelectorAll(".profileCategory")
        for (let c of categories) c.className = "profileCategory"
        if (e.innerText == "Избранное") this.profileCategory = "favourite"
        else this.profileCategory = "profile"
        e.classList.add("selectedProfileCategory")
      },
      closeModal() {
        this.isOpenPayment = false
      },
      getFavourites() {
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/favorite`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          })
          .then((res) => {
            this.favouriteGirls = res.data.result.data.reverse()
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getHistory() {
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/order`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          })
          .then((res) => {
            console.log(res)
            this.historyGirls = res.data.result.reverse()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      reserveGirl(event) {
        let e = event.target.closest("button") || event.target.closest("img")
        const find = this.favouriteGirls.find((item) => item._id === e.id)
        if (find.addCity.name == this.$store.getters.getCity) window.location.href = `/girl/${e.id}`
        else this.toast.error("Модель из другого города!")
      },
      getPluralForm(number) {
        let forms = ["год", "года", "лет"]
        number = Math.abs(number) % 100
        const lastDigit = number % 10
        if (number > 10 && number < 20) return forms[2]
        if (lastDigit === 1) return forms[0]
        if (lastDigit >= 2 && lastDigit <= 4) return forms[1]
        return forms[2]
      },
      openPayment(event) {
        let e = event.target.closest("p")
        axios
          .get(`https://${process.env.VUE_APP_SERVERHOST}/api/order/${e.id}`, {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          })
          .then((res) => {
            console.log(res)
            const expires = new Date(res.data.result.expires)
            const now = new Date()
            console.log(now, expires)
            if (now < expires) {
              this.girlPaymentData = res
              this.isOpenPayment = true
            } else this.toast.error("Время оплаты истекло!")
          })
          .catch((err) => {
            console.log(err)
          })
      },
      logoutButton() {
        this.$store.commit("setUserData", null)
        window.location.href = "/"
      },
    },
    mounted() {
      this.getFavourites()
      this.getHistory()
    },
    setup() {
      const toast = useToast()
      return { toast }
    },
    components: {
      HeaderComponent,
      FooterComponent,
      GirlCard,
      PaymentCard,
    },
  }
</script>
<style scoped>
  .profileBlock {
    width: 64vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .goBack {
    display: flex;
    gap: 5px;
    margin-top: 3%;
    margin-bottom: 3%;
    cursor: pointer;
    width: fit-content;
  }
  .goBack p {
    font-weight: 600;
  }
  .profileMainInfo {
    display: flex;
    gap: 20px;
  }
  .profileBlockInfo {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .profileHeadText {
    font-size: 32px;
    font-weight: 600;
    color: #333333;
  }
  .userInfo {
    display: flex;
    gap: 15px;
    padding: 2%;
    border-radius: 10px;
    background-color: #f6fafd;
    min-width: 33%;
    justify-content: space-between;
    align-items: center;
  }
  .userInfo:nth-child(2) {
    justify-content: left;
  }
  .userInfoText {
    display: flex;
    gap: 15px;
  }
  .userTextHead {
    color: #333333;
    font-size: 18px;
  }
  .userTextData {
    color: #757575;
    font-size: 14px;
  }
  .logoutButton {
    background-color: #2f2f2f;
    color: white;
    font-weight: 600;
    border-radius: 50px;
    width: 30%;
    padding: 5px;
    border: 1px solid transparent;
    cursor: pointer;
  }
  .profileCategories {
    display: flex;
    gap: 15px;
  }
  .profileCategory {
    background-color: #fbfbfb;
    border: 1px solid #f4f4f4;
    border-radius: 33px;
    color: #333333;
    font-size: 18px;
    padding: 7px 23px 7px 23px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .selectedProfileCategory {
    background-color: #2f2f2f;
    color: white;
  }
  .workBlock {
    display: flex;
    flex-direction: column;
    margin-bottom: 5%;
  }
  .listQuestionnaires {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
  }
  .questionnaire {
    background-color: #fbfbfb;
    border: 1px solid #f4f4f4;
    border-radius: 10px;
    padding: 20px;
    gap: 10px;
    display: flex;
    flex-direction: column;
  }
  .mainInfoQuestionnaire {
    display: flex;
    height: 80%;
    gap: 20px;
  }
  .girlPhoto {
    width: 60%;
  }
  .girlPhoto img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
  .infoGirl {
    width: 70%;
  }
  .girlName {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    gap: 5px;
    align-items: center;
    position: relative;
  }

  .verifyPopUp {
    position: absolute;
    bottom: 125%; /* выше иконки */
    left: 50%;
    transform: translateX(-50%);
    background-color: #2f2f2f;
    color: #fff;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
    z-index: 10;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .verifyPopUp p {
    display: flex;
    align-items: center;
    margin-bottom: 0 !important;
    font-size: 14px;
    font-weight: 500;
  }

  .verify-wrapper:hover .verifyPopUp {
    opacity: 1;
  }
  .infoGirl p:nth-child(2) {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .priceGirl {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .featuresGirl {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .pinkFeature {
    background-color: #ff898926;
    color: #ff8989;
    font-size: 15px;
    font-weight: 600;
    border-radius: 10px;
    display: flex;
    padding: 5px 7px 5px 7px;
  }
  .blueFeature {
    background-color: #89bfff26;
    color: #89bfff;
    font-size: 15px;
    font-weight: 600;
    border-radius: 10px;
    padding: 5px 7px 5px 7px;
  }
  .hourRent {
    display: flex;
    gap: 20px;
  }
  .infoHour {
    display: flex;
    flex-direction: column;
    color: #2f2f2f;
  }
  .infoHour span {
    font-family: "Noto Sans";
    display: flex;
    align-items: center;
  }
  .priceSum {
    display: flex;
  }
  .paymentStatus {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .paymentStatusText {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5%;
    padding-left: 3%;
    padding-right: 3%;
    gap: 5px;
    font-weight: 600;
    border-radius: 10px;
  }
  .paymentNotPaid {
    color: #ff4f4f;
    background-color: #ff4f4f26;
    cursor: pointer;
  }
  .paymentPaid {
    color: #24f224;
    background-color: #24f22426;
  }
  .headInfoHour {
    display: flex;
    align-items: center;
    gap: 7px;
    font-weight: 600;
    color: #ff8989;
  }
  .headInfoHour p {
    text-align: center;
  }
  .infoHour:nth-child(3) .headInfoHour {
    color: #2f2f2f;
  }
  .reservationButton {
    background-color: #2f2f2f;
    border-radius: 10px;
    border: 1px solid #2f2f2f;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-weight: 600;
    color: #ffffff;
    padding: 10px;
    cursor: pointer;
  }
  .reservationBackground {
    background-color: #232323e5;
    backdrop-filter: blur(8px);
    color: white;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 5002;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .reservationBlock {
    width: 30vw;
    margin: 0 auto;
    border-radius: 10px;
    background-color: #ffffff;
    padding: 1% 2% 1% 2%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    transition: transform 0.3s ease, opacity 0.3s ease, height 0.3s ease-in-out;
  }
  .modalHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .closeAuth {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #2f2f2f;
    border-radius: 5px;
    padding: 2%;
    cursor: pointer;
  }
  @media (max-width: 968px) {
    .profileMainInfo {
      flex-direction: column;
    }
    .profileBlock {
      width: 90vw;
    }
    .listQuestionnaires {
      grid-template-columns: 1fr;
    }
    .reservationBlock {
      width: 90vw;
      padding: 5%;
    }
    .userInfo {
      padding: 5%;
    }
    .userInfoText img {
      width: 10vw;
    }
    .profileCategory {
      font-size: 16px;
    }
  }
  @media (max-width: 1200px) {
    .headInfoHour p {
      font-size: 14px;
    }
  }
</style>
